import React, { Component, Fragment } from 'react';
import {
  Tabs,
  Tab,
  Divider
} from '@material-ui/core';

import ShowCoupon from './ShowCoupon';
import Action from './Action';

class UserEdit extends Component {
  constructor (props) {
    super(props);
    this.state = { value: 0 };
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render () {
    const { value } = this.state;
    return (
      <Fragment>
        <Tabs
          fullWidth
          centered
          value={value}
          indicatorColor='primary'
          onChange={this.handleChange}
        >
          <Tab label='List' style={{ fontWeight: 'bold' }} />
          <Tab label='Generate' style={{ fontWeight: 'bold' }} />
        </Tabs>
        <Divider />
        { value === 0 && <ShowCoupon {...this.props} />}
        { value === 1 && <Action {...this.props} />}
      </Fragment>
    );
  }
}

export default UserEdit;
